import React from 'react';

const TotalRecords = ({ count }) => {
    return <div className="flex flex-row gap-1"><p>Total: </p><p className="font-bold">{count}</p></div>

}

export default TotalRecords;